import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import { connect, useDispatch } from "react-redux";

// import Custom Components
import SideBar from "../../features/sidebar/shop-filter";
import ProductListByBrand from "../../features/product/list/product-list-bybrand";
import PageHeader from "../../common/page-header";
import Breadcrumb from "../../common/breadcrumb";

import { getVariantsByBrandWithSlug } from "../../../actions/variantActions";

function VariantsByBrand(props) {
  const type = "boxed";
  const slug = props.match.params.slug;
  const title = {
    boxed: "Les produits de la Marque",
    fullwidth: "Les produits de la Marque",
  };

  const variants = props.variants;
  console.log({ variants, cond: variants.length > 0 });
  const dispatch = useDispatch();

  useEffect(() => {
    if (type !== "boxed" && type !== "fullwidth") {
      window.location = process.env.REACT_APP_PUBLIC_URL + "/pages/404";
    }
  }, [type]);

  function hideSideBar() {
    if (
      document.querySelector("body").classList.contains("sidebar-filter-active")
    )
      document.querySelector("body").classList.remove("sidebar-filter-active");
  }

  useEffect(() => {
    dispatch(getVariantsByBrandWithSlug(slug));
  }, [slug]);

  if (!variants) {
    return "Loading Variants...";
  }

  return (
    <>
      <Helmet>
        <title>Les produits de la Marque</title>
      </Helmet>

      <h1 className="d-none">Les produits de la Marque</h1>

      <div className="main">
        {variants.length > 0 ? (
          <PageHeader
            title={variants[0].product.brand.nameFr}
            subTitle="Boutique"
          />
        ) : (
          <PageHeader title={"Nos Produits"} subTitle="Boutique" />
        )}

        <Breadcrumb
          title={title[type]}
          parent1={["Boutique", `shop/sidebar/list`]}
          adClass="mb-2"
          container={type === "boxed" ? "container" : "container-fluid"}
        />

        <div className="page-content">
          <div className={type === "boxed" ? "container" : "container-fluid"}>
            <ProductListByBrand type={type} />

            <div className="sidebar-filter-overlay" onClick={hideSideBar}></div>

            <SideBar numbers={50} />
          </div>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    variants: state.variants.variantsByBrandSlug
      ? state.variants.variantsByBrandSlug
      : [],
  };
}

export default connect(
  mapStateToProps,
  getVariantsByBrandWithSlug
)(React.memo(VariantsByBrand));
